import { render, staticRenderFns } from "./albumDetail.vue?vue&type=template&id=11d3595c&scoped=true&"
import script from "./albumDetail.vue?vue&type=script&lang=js&"
export * from "./albumDetail.vue?vue&type=script&lang=js&"
import style0 from "./albumDetail.vue?vue&type=style&index=0&id=11d3595c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./albumDetail.vue?vue&type=style&index=1&id=11d3595c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3595c",
  null
  
)

export default component.exports